export default __webpack_public_path__ + "static/media/ic_contest_active.4f1f6364.svg";